/* lunalume-set-seite · Seite "Set gestalten" (31.10.2026 Set-Seite)
 *
 * Auftrag Ilyas 31.10.2026: "eine neue kategorie mit set gestalten wo man eine optimale user journey hat um sich ein
 * set zusammen zu stellen mobile und desktop". Bauspezifikation der Jury 31.10.2026 (Konzept 2 "Leinwand").
 * Laedt NUR auf der Seite (Vorlage page.set-gestalten) und VOR lunalume-set.js. Der Baukasten selbst (Rechnung,
 * Schublade, Kabelgrenze, add.js) bleibt in lunalume-set.js; hier nur, was die Seite zusaetzlich braucht:
 *  - Start: der Sitzungsspeicher 'll-set-seite' (nur Baldachin, Plaetze, abgestellte Schirme und der schon angewandte
 *    URL-Schluessel; gegen Katalog-Stand und Seitendaten geprueft). ?baldachin=<schluessel> waehlt den Baldachin EINMAL
 *    je Sitzung vor und nimmt gespeicherte Schirme verlustfrei mit; Neuladen/Zurueck mit demselben Schluessel behaelt
 *    das Set (Review 31.10., Befund HOCH). NIE Mengen in URL oder Speicher (§ 312a Abs. 3 BGB: Mengen starten bei 0).
 *    Kein pushState, keine History-API, kein fetch, kein Polling.
 *  - Werk-Karten in der Schublade tragen "Ohne Mengenrabatt" (R2).
 *  - Schnellknopf "Freie Plaetze mit <Schirm> belegen" (nur mit Baldachin, >= 1 belegter und >= 1 freier Platz).
 *  - Stecker-Marken an den Plaetzen, die ein Anschlusskabel im Set abdeckt; Kabelstand im Kopf von "Licht und Strom".
 *  - Rabattbalken 3/6/9 in "Ihr Set" wie auf den Produktseiten (Fuellung, Punkte, "q % Mengenrabatt erreicht.").
 *  - Feste Leiste unter 1000 px: Summe (data-cent wie "Ihr Set"), Rabattzeile, PAngV-Zeile; Knopf "Weiter" bis
 *    "Licht und Strom" einmal im Bild war, danach "Set in den Warenkorb". Weg bei leerem Set, sobald "Ihr Set" im Bild
 *    oder schon darueber ist (Seitenfuss frei) und bei offener Schublade (CSS). Waehrend add.js gesperrt wie der Knopf
 *    in "Ihr Set"; ein Fehler holt die Meldung ins Bild. Baldachinwechsel per Zeiger (nie Pfeiltasten) holt unter
 *    1000 px den Plan ins Bild.
 * Die reine Logik (Seite.*) hat keinen DOM-Bezug und wird in Node getestet (tests/test_set_seite.js).
 */
(function () {
  'use strict';

  var Seite = (function () {
    var VERSION = 1;

    /* Wert eines Parameters aus location.search ('?a=1&baldachin=5' -> '5'), ohne URLSearchParams; fehlt er oder ist er
       leer -> null. Kaputte Kodierung (%E0) -> null, nie eine Ausnahme. */
    function schluesselAusSuche(suche, name) {
      var teile = String(suche == null ? '' : suche).replace(/^\?/, '').split('&');
      for (var i = 0; i < teile.length; i++) {
        var paar = teile[i].split('=');
        var k = paar.shift();
        var wert = paar.join('=');
        try {
          k = decodeURIComponent(k.replace(/\+/g, ' '));
          wert = decodeURIComponent(wert.replace(/\+/g, ' '));
        } catch (fehler) {
          continue;
        }
        if (k === name) return wert === '' ? null : wert;
      }
      return null;
    }

    /* Handle des Baldachins mit Schluessel k (Seitendaten b.k), nur wenn er bestellbar ist; sonst null */
    function baldachinAusSchluessel(baldachine, k) {
      if (k == null || k === '') return null;
      var liste = baldachine || [];
      for (var i = 0; i < liste.length; i++) {
        var b = liste[i];
        if (b && b.k === k && b.ok !== false) return b.h;
      }
      return null;
    }

    function leerePlaetze(n) {
      var aus = [];
      for (var i = 0; i < n; i++) aus.push(null);
      return aus;
    }

    /* Ein gespeicherter Platz -> {h, v} oder null (unbekannter/nicht verfuegbarer Schirm, unbekannte oder nicht
       verfuegbare Variante) */
    function platzPruefen(e, d, L) {
      if (!e || typeof e !== 'object' || typeof e.h !== 'string') return null;
      var s = L.finde(d.schirme, e.h);
      if (!s || !L.schirmOk(s)) return null;
      var va = L.variante(s, e.v == null ? s.v : e.v);
      if (!va || va.ok === false) return null;
      return { h: s.h, v: va.id };
    }

    function leererStart() {
      return { baldachin: null, plaetze: [], abgestellt: [], q: null };
    }

    /* Sitzungsspeicher pruefen: roh = JSON {v:1, stand, b, p:[{h,v}|null], a?:[{h,v}], q?:'5'}. Kaputtes JSON, andere
       Version oder anderer Katalog-Stand -> null. Unbekannte/nicht verfuegbare Baldachine, Schirme, Varianten werden
       null bzw. fallen weg; die Platzzahl folgt dem Baldachin (L.baldachinWechsel, ohne Baldachin hoechstens maxFrei).
       Was nicht auf die Plaetze passt, geht NICHT verloren, sondern bleibt abgestellt (wie beim Baldachinwechsel,
       Befund HOCH 04.10.); abgestellt hoechstens maxFrei. q = der URL-Schluessel, der in dieser Sitzung schon
       angewandt wurde (Review 31.10.: Neuladen/Zurueck mit ?baldachin= darf das Set nicht leeren).
       Liefert {baldachin, plaetze, abgestellt, q}. */
    function zustandPruefen(roh, d, L) {
      if (typeof roh !== 'string' || roh === '') return null;
      var z;
      try {
        z = JSON.parse(roh);
      } catch (fehler) {
        return null;
      }
      if (!z || typeof z !== 'object' || z.v !== VERSION) return null;
      if (!d || z.stand !== d.stand) return null;
      var max = d.maxFrei || 12;
      var b = null;
      if (typeof z.b === 'string' && z.b !== '') {
        var kand = L.finde(d.baldachine, z.b);
        b = kand && kand.ok !== false ? kand : null;
      }
      var p = Array.isArray(z.p) ? z.p : [];
      var plaetze = p.map(function (e) { return platzPruefen(e, d, L); });
      var a = (Array.isArray(z.a) ? z.a : []).map(function (e) { return platzPruefen(e, d, L); }).filter(Boolean);
      var r = L.baldachinWechsel(plaetze, [], b ? b.a : null, max);
      return {
        baldachin: b ? b.h : null,
        plaetze: r.plaetze,
        abgestellt: r.abgestellt.concat(a).slice(0, max),
        q: typeof z.q === 'string' && z.q !== '' ? z.q : null
      };
    }

    /* Startzustand der Seite. Ohne URL-Schluessel: der gepruefte Speicher, sonst leer. Mit Schluessel (Link von einer
       Baldachin-Seite) gilt er EINMAL je Sitzung (Review 31.10., Befund HOCH): wurde genau dieser Schluessel schon
       angewandt (gespeichertes q, also Neuladen, Zurueck, erneuter Klick), gewinnt der Speicher ganz — auch ein auf
       der Seite gewaehlter anderer Baldachin. Ein neuer, gueltiger Schluessel waehlt den Baldachin und nimmt die
       gespeicherten Schirme verlustfrei mit (L.baldachinWechsel: was nicht passt, bleibt abgestellt). Ein unbekannter
       oder nicht bestellbarer Schluessel aendert nichts: der Speicher gilt, sonst leer.
       Liefert {baldachin, plaetze, abgestellt, q} — NIE Zubehoermengen. */
    function startAus(d, L, suche, roh) {
      var dd = d || {};
      var k = schluesselAusSuche(suche, 'baldachin');
      var z = zustandPruefen(roh, dd, L);
      if (k === null) return z || leererStart();
      var h = baldachinAusSchluessel(dd.baldachine, k);
      if (!h) return z || leererStart();
      if (z && z.q === k) return z;
      var b = L.finde(dd.baldachine, h);
      if (!z) return { baldachin: h, plaetze: leerePlaetze(b ? b.a : 0), abgestellt: [], q: k };
      if (z.baldachin === h) return { baldachin: h, plaetze: z.plaetze, abgestellt: z.abgestellt, q: k };
      var r = L.baldachinWechsel(z.plaetze, z.abgestellt, b ? b.a : null, dd.maxFrei || 12);
      return { baldachin: h, plaetze: r.plaetze, abgestellt: r.abgestellt, q: k };
    }

    /* Schnellknopf: jeder freie Platz (null) bekommt den Schirm eintrag {h, v}; neue Liste, Eingabe bleibt */
    function freieBelegen(plaetze, eintrag) {
      if (!eintrag) return (plaetze || []).slice();
      return (plaetze || []).map(function (e) { return e ? e : { h: eintrag.h, v: eintrag.v }; });
    }

    function gleich(a, b) {
      if (!a || !b) return false;
      var ha = typeof a === 'string' ? a : a.h, hb = typeof b === 'string' ? b : b.h;
      var va = typeof a === 'string' ? null : a.v, vb = typeof b === 'string' ? null : b.v;
      return ha === hb && Number(va) === Number(vb);
    }

    /* erster Platz, der neu belegt oder getauscht wurde -> {h, v}; sonst null */
    function zuletztGesetzt(vorher, nachher) {
      var alt = vorher || [], neu = nachher || [];
      for (var i = 0; i < neu.length; i++) {
        var e = neu[i];
        if (e && !gleich(alt[i], e)) return { h: typeof e === 'string' ? e : e.h, v: typeof e === 'string' ? null : e.v };
      }
      return null;
    }

    /* Vorlage fuer den Schnellknopf: der zuletzt gesetzte Schirm, wenn er noch auf einem Platz steht; sonst der Schirm
       auf dem ersten belegten Platz (z. B. nach dem Wiederherstellen); leerer Plan -> null */
    function schnellVorlage(plaetze, zuletzt) {
      var liste = plaetze || [];
      if (zuletzt && liste.some(function (e) { return gleich(e, zuletzt); })) return { h: zuletzt.h, v: zuletzt.v };
      for (var i = 0; i < liste.length; i++) {
        if (liste[i]) return { h: liste[i].h, v: liste[i].v };
      }
      return null;
    }

    /* Plaetze mit Stecker-Marke: die ersten min(kabelM, belegte) belegten Plaetze (Indizes) */
    function abgedeckt(plaetze, kabelM) {
      var aus = [], rest = Math.max(0, Math.floor(Number(kabelM) || 0));
      (plaetze || []).forEach(function (e, i) {
        if (e && rest > 0) { aus.push(i); rest--; }
      });
      return aus;
    }

    /* Inhalt der festen Leiste aus dem Stand des Baukastens (E3): zeigen = Set nicht leer, cent = Summe wie "Ihr Set",
       zeile = Rabattposten (mit Warenkorb-Fassung), sonst ''. Der Anreiz steht NICHT in der Leiste (zu lang). */
    function leisteInhalt(stand, t, L) {
      var s = stand || {}, tt = t || {}, r = s.r;
      var zeile = '';
      if (s.mit && r && r.stufe) {
        var p = L.prozentText(r.stufe.p);
        zeile = r.korb > 0
          ? L.text(tt.rabattPostenKorb, { n: r.gesamt, k: r.korb, p: p })
          : L.text(tt.rabattPosten, { n: r.anzahl, p: p });
      }
      return { zeigen: !L.setLeer(s.pos || []), cent: Number(s.summeCent) || 0, zeile: zeile };
    }

    /* Leistenknopf: 'weiter', bis "Licht und Strom" einmal im Bild war — ausser es ist dort nichts waehlbar */
    /* Rabattbalken (31.10.2026 abends): n gezaehlte Artikel (Set + Warenkorb), max = hoechste Stufe, stufen = [{ab, p}]
       aufsteigend. -> { breite: '0%'..'100%', erreicht: ab der erreichten Stufe (0 = keine), text: Wortlaut der
       Produktseite (volume-goal-bar.liquid vg_txt_zwischen/_max, nur der erreichte Teil; "noch n" sagt die Anreizzeile) } */
    function balken(n, max, stufen) {
      var zahl = Math.max(0, Math.floor(Number(n) || 0));
      var breite = max > 0 ? Math.min(100, Math.round((zahl * 100) / max)) + '%' : '0%';
      var erreicht = 0, p = '', hoechste = false;
      (stufen || []).forEach(function (s, i) {
        if (s && s.ab > 0 && zahl >= s.ab) { erreicht = s.ab; p = s.p; hoechste = i === stufen.length - 1; }
      });
      var text = !erreicht ? '' : hoechste
        ? p + '\u00a0% Mengenrabatt erreicht \u2013 die h\u00f6chste Stufe.'
        : p + '\u00a0% Mengenrabatt erreicht.';
      return { breite: breite, erreicht: erreicht, text: text };
    }

    function knopfArt(lichtGesehen, lichtWaehlbar) {
      return lichtGesehen || !lichtWaehlbar ? 'korb' : 'weiter';
    }

    function eintragText(e) {
      if (!e) return null;
      return typeof e === 'string' ? { h: e, v: null } : { h: e.h, v: e.v == null ? null : e.v };
    }

    /* Speichertext: nur Baldachin, Plaetze und abgestellte Schirme ({h, v}), Version, Katalog-Stand und der schon
       angewandte URL-Schluessel q (nur wenn gesetzt); leeres Set (nichts gewaehlt, nichts abgestellt) -> '' */
    function serialisieren(st, d, q) {
      var s = st || {};
      var plaetze = (s.plaetze || []).map(eintragText);
      var abgestellt = (s.abgestellt || []).map(eintragText).filter(Boolean);
      var belegt = plaetze.filter(Boolean).length;
      if (!s.baldachin && !belegt && !abgestellt.length) return '';
      var z = { v: VERSION, stand: (d && d.stand) || '', b: s.baldachin || null, p: plaetze };
      if (abgestellt.length) z.a = abgestellt;
      if (typeof q === 'string' && q !== '') z.q = q;
      return JSON.stringify(z);
    }

    /* Feste Leiste weg, sobald "Ihr Set" erreicht ist: im Bild ODER schon ueber dem oberen Rand (Review 31.10.: sonst
       kam sie im Seitenfuss zurueck und verdeckte die letzten Links). e = IntersectionObserverEntry */
    function korbErreicht(e) {
      if (!e) return false;
      return !!e.isIntersecting || (!!e.boundingClientRect && e.boundingClientRect.top < 0);
    }

    /* Karte bekommt "Ohne Mengenrabatt": Schirm mit Typ, der nicht zur Staffel zaehlt (Werk) */
    function ohneRabatt(s, L) {
      return !!s && s.t != null && !L.rabattTyp(s.t);
    }

    return {
      VERSION: VERSION, schluesselAusSuche: schluesselAusSuche, baldachinAusSchluessel: baldachinAusSchluessel,
      zustandPruefen: zustandPruefen, startAus: startAus, freieBelegen: freieBelegen, zuletztGesetzt: zuletztGesetzt,
      schnellVorlage: schnellVorlage, abgedeckt: abgedeckt, leisteInhalt: leisteInhalt, knopfArt: knopfArt, balken: balken,
      serialisieren: serialisieren, ohneRabatt: ohneRabatt, korbErreicht: korbErreicht
    };
  })();

  if (typeof module === 'object' && module.exports) {
    module.exports = Seite;
    return;
  }

  /* ================================================================ Browser */
  var SPEICHER = 'll-set-seite';
  var GRENZE_BREIT = '(min-width: 1000px)';
  var STECKER_SVG = '<svg aria-hidden="true" focusable="false" width="12" height="12" viewBox="0 0 12 12" fill="none">' +
    '<path d="M4 1v3M8 1v3M2.5 4h7v2.5a3.5 3.5 0 0 1-7 0V4ZM6 10v1.5" stroke="currentColor" stroke-width="1.2" ' +
    'stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', '\'': '&#39;' }[c];
    });
  }

  function speicherLesen() {
    try {
      return window.sessionStorage.getItem(SPEICHER);
    } catch (fehler) {
      return null;
    }
  }

  function speicherSchreiben(text) {
    try {
      if (text) window.sessionStorage.setItem(SPEICHER, text);
      else window.sessionStorage.removeItem(SPEICHER);
    } catch (fehler) {
      /* privates Fenster / gesperrter Speicher: die Seite laeuft ohne Wiederherstellung */
    }
  }

  function ruhig() {
    return !!window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function breit() {
    return !!window.matchMedia && window.matchMedia(GRENZE_BREIT).matches;
  }

  /* angewandter URL-Schluessel je Seitendaten (die Steuerung schreibt ihn mit in den Speicher) */
  var startQ = { d: null, q: null };

  /* E2: lunalume-set.js ruft das im Seitenmodus auf (try/catch dort) */
  function start(d, L) {
    var suche = '';
    try {
      suche = window.location.search;
    } catch (fehler) {
      suche = '';
    }
    var r = Seite.startAus(d, L, suche, speicherLesen());
    startQ = { d: d, q: r.q };
    return r;
  }

  window.LunalumeSetSeite = { start: start, logik: Seite };

  /* ---------------------------------------------------------------- Steuerung je Baukasten */
  function Steuerung(bk) {
    var el = bk.el;
    this.bk = bk;
    this.L = window.LunalumeSetLogik;
    this.t = bk.t || {};
    this.leiste = el.querySelector('[data-ll-ss-leiste]');
    this.betrag = el.querySelector('[data-ll-ss-betrag]');
    this.zeileEl = el.querySelector('[data-ll-ss-zeile]');
    this.knopf = el.querySelector('[data-ll-ss-knopf]');
    this.schnell = el.querySelector('[data-ll-ss-schnell]');
    this.fuellen = el.querySelector('[data-ll-ss-fuellen]');
    this.kabelstand = el.querySelector('[data-ll-ss-kabelstand]');
    this.stufen = el.querySelector('[data-ll-ss-stufen]');
    this.korbTeil = el.querySelector('.ll-bk__teil--korb');
    this.lichtTeil = el.querySelector('.ll-bk__teil--licht');
    this.lichtTitel = this.lichtTeil ? this.lichtTeil.querySelector('h3') : null;
    this.planTeil = el.querySelector('.ll-bk__plan');
    this.baldachinTeil = el.querySelector('.ll-bk__teil--baldachin');
    this.lichtGesehen = false;
    this.korbSichtbar = false;
    this.zeiger = false;
    this.zuletzt = null;
    this.vorher = (bk.st.plaetze || []).slice();
    this.vorherB = bk.st.baldachin;
    this.schnellEintrag = null;
    this.korbText = null;
    this.letzterStand = null;
    this.q = startQ.d === bk.d ? startQ.q : null;
    this.werkMarken();
    this.binden();
    this.beobachten();
    this.aktualisieren();
  }

  /* (1) Werk-Karten: "Ohne Mengenrabatt" vor der Marke "Gewaehlt" (nur mit Mengenrabatt-Anzeige) */
  Steuerung.prototype.werkMarken = function () {
    var bk = this.bk, L = this.L, t = this.t;
    if (!bk.rabatt || !t.ohneRabatt || !bk.drawer) return;
    (bk.d.schirme || []).forEach(function (s) {
      if (!Seite.ohneRabatt(s, L)) return;
      var karte = bk.karteVon(s.h);
      var marke = karte ? karte.querySelector('.ll-bk-karte__marke') : null;
      if (!marke || karte.querySelector('.ll-bk-karte__ohne')) return;
      marke.insertAdjacentHTML('beforebegin', '<span class="ll-bk-karte__ohne">' + esc(t.ohneRabatt) + '</span>');
    });
  };

  /* (2) Klicks, (3) Zeiger am Baldachin, (6) Warenkorb */
  Steuerung.prototype.binden = function () {
    var self = this, bk = this.bk, el = bk.el;
    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-ll-ss-fuellen]')) { self.freieFuellen(); return; }
      if (e.target.closest('[data-ll-ss-knopf]')) self.leisteKlick();
    });
    if (this.baldachinTeil) {
      this.baldachinTeil.addEventListener('pointerdown', function () { self.zeiger = true; });
      this.baldachinTeil.addEventListener('keydown', function () { self.zeiger = false; });
    }
    /* auf el registriert NACH lunalume-set.js -> laeuft nach baldachinSetzen() (Plan ist neu gezeichnet) */
    el.addEventListener('change', function (e) {
      var w = e.target.closest && e.target.closest('[data-ll-bk-baldachin]');
      var zeiger = self.zeiger;
      self.zeiger = false;
      if (w && zeiger) self.planZeigen();
    });
    el.addEventListener('lunalume:set-render', function () { self.aktualisieren(); });
    el.addEventListener('lunalume:set-im-korb', function () {
      self.korbText = Seite.serialisieren(bk.st, bk.d, self.q);
      speicherSchreiben('');
    });
    /* E8: add.js gescheitert — die Meldung steht in "Ihr Set" (unter der festen Leiste nicht im Bild) */
    el.addEventListener('lunalume:set-fehler', function () { self.meldungZeigen(); });
  };

  /* Fehler nach "Set in den Warenkorb" (Review 31.10.): die Meldung ins Bild holen — nur so weit wie noetig (im Bild:
     nichts). Unter 1000 px kommt so "Ihr Set" ins Bild und die Leiste geht weg; ab 1000 px rollt nur "Ihr Set" selbst. */
  Steuerung.prototype.meldungZeigen = function () {
    var m = this.bk.meldung;
    if (!m || !m.textContent || typeof m.scrollIntoView !== 'function') return;
    m.scrollIntoView({ block: 'nearest', behavior: ruhig() ? 'auto' : 'smooth' });
  };

  /* Unter 1000 px nach einem Baldachinwechsel per Zeiger den Plan ins Bild holen (nur so weit wie noetig) */
  Steuerung.prototype.planZeigen = function () {
    if (breit() || !this.planTeil || typeof this.planTeil.scrollIntoView !== 'function') return;
    this.planTeil.scrollIntoView({ block: 'nearest', behavior: ruhig() ? 'auto' : 'smooth' });
  };

  Steuerung.prototype.platzOk = function (e) {
    var L = this.L, s = e ? L.finde(this.bk.d.schirme, L.handleVon(e)) : null;
    if (!s) return false;
    var va = L.variante(s, e.v == null ? s.v : e.v);
    return !!va && va.ok !== false;
  };

  Steuerung.prototype.freieFuellen = function () {
    var bk = this.bk, L = this.L, e = this.schnellEintrag;
    if (!e || !this.platzOk(e)) return;
    var erster = bk.st.plaetze.indexOf(null);
    bk.st.plaetze = Seite.freieBelegen(bk.st.plaetze, e);
    if (bk.meldung) bk.meldung.textContent = '';
    bk.nachSchirmen();
    var b = bk.st.baldachin ? L.finde(bk.d.baldachine, bk.st.baldachin) : null;
    bk.ansagen(L.text(this.t.belegung, { belegt: L.belegt(bk.st.plaetze), plaetze: b ? b.a : bk.st.plaetze.length }));
    /* der Knopf ist jetzt weg (kein freier Platz) -> Fokus auf den ersten neu belegten Platz statt auf BODY */
    if (erster >= 0) bk.fokusPlatz(erster);
  };

  Steuerung.prototype.leisteKlick = function () {
    if (!this.knopf || this.knopf.disabled || this.knopf.getAttribute('aria-busy') === 'true') return;
    if (this.art === 'weiter') {
      var h = this.lichtTitel;
      this.lichtGesehen = true;
      if (h) {
        if (typeof h.scrollIntoView === 'function') h.scrollIntoView({ block: 'start', behavior: ruhig() ? 'auto' : 'smooth' });
        h.focus({ preventScroll: true });
      }
      this.leisteSetzen();
      return;
    }
    this.bk.inDenWarenkorb();
  };

  /* (4) "Ihr Set" erreicht (im Bild oder schon darueber, Seite.korbErreicht) -> Leiste aus; "Licht und Strom" zu 25 %
     im Bild -> gesehen (bleibt wahr).
     Dazu: der Stand aendert sich auch ohne render() (Warenkorb-Ereignisse -> korbSetzen -> renderSumme setzt data-cent
     an der Summe) -> ein MutationObserver nur auf dieses Attribut, ohne Schleife (hier wird es nie geschrieben).
     Und: waehrend add.js setzt lunalume-set.js aria-busy/aria-disabled am Knopf in "Ihr Set", ohne neu zu zeichnen ->
     ein zweiter MutationObserver spiegelt das an den Leistenknopf (schreibt nur dort, keine Schleife). */
  Steuerung.prototype.beobachten = function () {
    var self = this, bk = this.bk;
    if (window.IntersectionObserver) {
      if (this.korbTeil) {
        new IntersectionObserver(function (eintraege) {
          eintraege.forEach(function (e) { self.korbSichtbar = Seite.korbErreicht(e); });
          self.leisteSetzen();
        }, { rootMargin: '0px 0px -64px 0px' }).observe(this.korbTeil);
      }
      if (this.lichtTeil) {
        var licht = new IntersectionObserver(function (eintraege) {
          eintraege.forEach(function (e) {
            var hoch = e.isIntersecting && e.intersectionRect.height >= window.innerHeight * 0.5;
            if (e.intersectionRatio >= 0.25 || hoch) self.lichtGesehen = true;
          });
          if (self.lichtGesehen) {
            licht.disconnect();
            self.leisteSetzen();
          }
        }, { threshold: [0, 0.1, 0.25] });
        licht.observe(this.lichtTeil);
      }
    } else {
      this.lichtGesehen = true;
    }
    if (window.MutationObserver && bk.summeEl) {
      new MutationObserver(function () {
        if (bk.stand !== self.letzterStand) self.aktualisieren();
      }).observe(bk.summeEl, { attributes: true, attributeFilter: ['data-cent'] });
    }
    if (window.MutationObserver && bk.knopf && this.knopf) {
      new MutationObserver(function () { self.leisteSetzen(); })
        .observe(bk.knopf, { attributes: true, attributeFilter: ['aria-busy', 'aria-disabled', 'disabled'] });
    }
  };

  /* (5) nach jedem Zeichnen des Baukastens und einmal sofort */
  Steuerung.prototype.aktualisieren = function () {
    var bk = this.bk, L = this.L, st = bk.st;
    this.letzterStand = bk.stand;
    /* zuletzt: nur bei gleichem Baldachin und ohne Entfernen (sonst waeren verschobene Plaetze "neu") */
    if (st.baldachin === this.vorherB && L.belegt(st.plaetze) >= L.belegt(this.vorher)) {
      var neu = Seite.zuletztGesetzt(this.vorher, st.plaetze);
      if (neu) this.zuletzt = neu;
    }
    this.vorher = (st.plaetze || []).slice();
    this.vorherB = st.baldachin;
    this.schnellSetzen();
    this.steckerSetzen();
    this.kabelstandSetzen();
    this.stufenSetzen();
    this.leisteSetzen();
    this.speichern();
  };

  Steuerung.prototype.schnellSetzen = function () {
    var bk = this.bk, L = this.L, st = bk.st;
    if (!this.schnell || !this.fuellen) return;
    var b = st.baldachin ? L.finde(bk.d.baldachine, st.baldachin) : null;
    var belegt = L.belegt(st.plaetze);
    var frei = b ? st.plaetze.length - belegt : 0;
    var vorlage = Seite.schnellVorlage(st.plaetze, this.zuletzt);
    var zeigen = !!b && belegt >= 1 && frei >= 1 && !!vorlage && this.platzOk(vorlage);
    var hatteFokus = document.activeElement === this.fuellen;
    this.schnellEintrag = zeigen ? vorlage : null;
    if (zeigen) {
      var text = L.text(this.t.freieBelegen, { name: bk.platzName(vorlage) });
      if (this.fuellen.textContent !== text) this.fuellen.textContent = text;
    }
    this.schnell.hidden = !zeigen;
    if (hatteFokus && !zeigen) bk.fokusPlatz(0);
  };

  Steuerung.prototype.steckerSetzen = function () {
    var bk = this.bk, self = this, plan = bk.plan;
    if (!plan) return;
    Array.prototype.forEach.call(plan.querySelectorAll('.ll-bk-platz__kabel'), function (m) { m.parentNode.removeChild(m); });
    var kabel = bk.zeile('kabel');
    var m = kabel && kabel.bestellbar ? kabel.m : 0;
    if (!m) return;
    var plaetze = (bk.st.plaetze || []).map(function (e) { return e && self.platzOk(e) ? e : null; });
    Seite.abgedeckt(plaetze, m).forEach(function (i) {
      var k = plan.querySelector('[data-ll-bk-platz="' + i + '"]');
      var li = k ? k.closest('li') : null;
      if (li) li.insertAdjacentHTML('beforeend', '<span class="ll-bk-platz__kabel" aria-hidden="true">' + STECKER_SVG + '</span>');
    });
  };

  Steuerung.prototype.lichtWaehlbar = function () {
    var bk = this.bk;
    if (bk.zeilenListe && bk.zeilenListe.hidden) return false;
    return (bk.zeilen || []).some(function (z) { return z.bestellbar; });
  };

  Steuerung.prototype.kabelstandSetzen = function () {
    var bk = this.bk, el = this.kabelstand;
    if (!el) return;
    var kabel = bk.zeile('kabel');
    var g = bk.kabelGrenze();
    var zeigen = !!kabel && kabel.bestellbar && g > 0 && !(bk.zeilenListe && bk.zeilenListe.hidden);
    if (zeigen) {
      var text = this.L.text(this.t.kabelStand, { k: kabel.m, g: g });
      if (el.textContent !== text) el.textContent = text;
    }
    el.hidden = !zeigen;
  };

  /* Rabattbalken wie auf den Produktseiten (31.10.2026 abends, Ilyas: "die Anzeige muss noch funktionieren"):
     Fuellung bis zur hoechsten Stufe, Punkte und Ziele ab erreichter Stufe markiert, Zeile "q % ... erreicht." */
  Steuerung.prototype.stufenSetzen = function () {
    if (!this.stufen) return;
    var r = this.bk.stand ? this.bk.stand.r : null;
    var n = r ? (r.korb > 0 ? r.gesamt : r.anzahl) : 0;
    var b = Seite.balken(n, Number(this.stufen.getAttribute('data-max')) || 0,
      Array.prototype.map.call(this.stufen.querySelectorAll('.ll-bk-stufen__ziel[data-ab]'), function (z) {
        return { ab: Number(z.getAttribute('data-ab')), p: z.getAttribute('data-p') };
      }));
    var fuell = this.stufen.querySelector('[data-ll-ss-fuell]');
    if (fuell && fuell.style.width !== b.breite) fuell.style.width = b.breite;
    Array.prototype.forEach.call(this.stufen.querySelectorAll('[data-ab]'), function (el) {
      var hit = b.erreicht > 0 && Number(el.getAttribute('data-ab')) <= b.erreicht;
      if (el.classList.contains('is-hit') !== hit) el.classList.toggle('is-hit', hit);
    });
    var zeile = this.stufen.querySelector('[data-ll-ss-stufen-text]');
    if (zeile) {
      if (zeile.textContent !== b.text) zeile.textContent = b.text;
      zeile.hidden = !b.text;
    }
  };

  Steuerung.prototype.leisteSetzen = function () {
    var bk = this.bk, L = this.L, t = this.t;
    if (!this.leiste || !bk.stand) return;
    var inhalt = Seite.leisteInhalt(bk.stand, t, L);
    var geld = bk.geld(inhalt.cent);
    if (this.betrag) {
      if (this.betrag.textContent !== geld) this.betrag.textContent = geld;
      this.betrag.setAttribute('data-cent', String(inhalt.cent));
    }
    if (this.zeileEl) {
      if (this.zeileEl.textContent !== inhalt.zeile) this.zeileEl.textContent = inhalt.zeile;
      this.zeileEl.hidden = !inhalt.zeile;
    }
    this.art = Seite.knopfArt(this.lichtGesehen, this.lichtWaehlbar());
    if (this.knopf) {
      var text = this.art === 'weiter' ? (t.weiter || '') : bk.knopf.textContent.trim();
      if (this.knopf.textContent !== text) this.knopf.textContent = text;
      if (this.art === 'weiter') this.knopf.setAttribute('aria-label', L.text(t.weiterLabel, { schritt: t.schrittLicht }));
      else this.knopf.removeAttribute('aria-label');
      this.knopf.disabled = !!bk.knopf.disabled;
      /* waehrend add.js wie der Knopf in "Ihr Set": fokussierbar, aber gesperrt (Review 31.10.) */
      var belegt = this.art === 'korb' && bk.knopf.getAttribute('aria-busy') === 'true';
      if (belegt) {
        if (this.knopf.getAttribute('aria-busy') !== 'true') this.knopf.setAttribute('aria-busy', 'true');
        if (this.knopf.getAttribute('aria-disabled') !== 'true') this.knopf.setAttribute('aria-disabled', 'true');
      } else {
        if (this.knopf.hasAttribute('aria-busy')) this.knopf.removeAttribute('aria-busy');
        if (this.knopf.hasAttribute('aria-disabled')) this.knopf.removeAttribute('aria-disabled');
      }
    }
    var aus = !inhalt.zeigen || this.korbSichtbar;
    var hatteFokus = !!this.knopf && document.activeElement === this.knopf;
    if (this.leiste.hidden !== aus) this.leiste.hidden = aus;
    if (hatteFokus && aus) bk.knopf.focus({ preventScroll: true });
    if (typeof bk.leisteNeu === 'function') bk.leisteNeu();
  };

  /* Sitzungsspeicher: nur Baldachin, Plaetze, abgestellte Schirme und der angewandte URL-Schluessel; leer -> entfernen.
     Nach "Set in den Warenkorb" bleibt er leer, bis sich am Set etwas aendert (Warenkorb-Ereignisse zeichnen neu, ohne
     dass sich das Set aendert) */
  Steuerung.prototype.speichern = function () {
    var text = Seite.serialisieren(this.bk.st, this.bk.d, this.q);
    if (this.korbText !== null) {
      if (text === this.korbText) return;
      this.korbText = null;
    }
    speicherSchreiben(text);
  };

  document.addEventListener('lunalume:set-bereit', function (e) {
    var bk = e.detail && e.detail.baukasten;
    if (!bk || !bk.d || bk.d.modus !== 'seite' || bk.llSeite || !window.LunalumeSetLogik) return;
    try {
      bk.llSeite = new Steuerung(bk);
    } catch (fehler) {
      if (window.console) console.error('lunalume-set-seite', fehler);
    }
  });
})();
